import { Box, Skeleton, Stack } from '@mui/material'
import { useState } from 'react'
import { IconButton } from 'utoniq-ui'

import { ItemThumbnailType } from '@/clients/utoniq-core/schema'
import { ItemReversibleThumbnail, ItemStatusCell } from '@/components/organisms'
import { AudioPlayModal } from '@/components/pages/OwnedItemDetail/template/components/resourceView/OwnedItemDetailAudioView'
import { ThumbnailActionAreaCell } from '@/components/pages/OwnedItemDetail/template/components/ThumbnailActionArea'
import { Cell } from '@/core/architecture'

import { State } from './'
import { ConsoleItemDescription } from './ConsoleItemDescription'

export type ConsoleItemDetailAudioProps = {
  loading: boolean
  item: State['item']
  isFlipped: boolean
  onReverseThumbnail: () => void
  onOpenFullScreen: () => void
  onOpenMultipleImage: () => void
}

export const ConsoleItemDetailAudio: Cell<ConsoleItemDetailAudioProps> = ({
  loading,
  item,
  isFlipped,
  onReverseThumbnail,
  onOpenFullScreen,
  onOpenMultipleImage,
}) => {
  const [displayResource, setDisplayResource] = useState(false)
  return (
    <>
      <Box sx={{ position: 'relative' }}>
        <ThumbnailActionAreaCell
          onOpenFullScreen={onOpenFullScreen}
          onOpenMultipleImage={onOpenMultipleImage}
          numberImage={item?.images?.length ?? 0}
        />
        <ItemReversibleThumbnail
          loading={loading}
          flipProps={{
            isFlipped,
          }}
          btnPlay={{
            type: 'back',
            onClick: () => setDisplayResource(prevState => !prevState),
          }}
          imageAreaProps={{
            thumbnail: item?.thumbnail,
            size:
              item?.thumbnailType === ItemThumbnailType.Square
                ? 'x-large-square'
                : 'x-large',
            onClick: onReverseThumbnail,
          }}
        />
      </Box>
      {item && !loading && (
        <Stack sx={{ pt: 3 }}>
          <ItemStatusCell
            salesCondition={item.salesCondition}
            isPublished={item.isPublished}
            isDrm={item.isDrm}
            isPremium={item.isPremium}
          />
        </Stack>
      )}
      <ConsoleItemDescription item={item} loading={loading} />

      <Box sx={{ mt: 6, mb: 2 }}>
        {loading && <Skeleton width={30} height={30} variant="circular" />}
        {!loading && isFlipped && (
          <IconButton.Rotate
            size="small"
            onClick={onReverseThumbnail}
            bgcolor="primary.main"
            color="white"
          />
        )}
        {!loading && !isFlipped && (
          <IconButton.AudioOn
            size="small"
            onClick={onReverseThumbnail}
            bgcolor="primary.main"
            color="white"
          />
        )}
      </Box>
      {item && (
        <AudioPlayModal
          open={displayResource}
          onClose={() => setDisplayResource(prevState => !prevState)}
          item={item}
        />
      )}
    </>
  )
}
